import { render, staticRenderFns } from "./RightsRequestForm.vue?vue&type=template&id=6587868d&scoped=true&"
import script from "./RightsRequestForm.vue?vue&type=script&lang=js&"
export * from "./RightsRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./RightsRequestForm.vue?vue&type=style&index=0&id=6587868d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587868d",
  null
  
)

export default component.exports